import {useFormik} from 'formik'
import {useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {toast} from 'react-toastify'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../../_metronic/helpers'
import {constraintConfig} from '../../../../constraintConfig'
import {selectAuth} from '../../../../features/authSlice'
import {useAppSelector} from '../../../../hooks'
import {
  useDeleteReceiptByExpenseItemIdMutation,
  useUploadOCRInvoiceMutation,
} from '../../../../services/BackgroundJobApi'
import {
  useAddUpdateCardExpenseItemMutation,
  useAddUpdateExpenseItemV2WebMutation,
} from '../../../../services/ExpenseApi'
import {useUploadFileToAzureMutation} from '../../../../services/IntegrartionApi'
import {useGetSingleOrganizationQuery} from '../../../../services/OrganizationApi'
import labelKey from '../../../localization/label.json'
import tosterKey from '../../../localization/toster.json'
import Step2 from './steps/Step2'
import {Step5} from './steps/Step5'
import axios from 'axios'
import {API_END_POINTS} from '../../../../services/apiEndpoints'
import AddCardModal from '../../vendorAndCard/card/AddCardModal'
type Props = {
  show: boolean
  handleClose: () => void
  data?: any
  violationLineItem?: any
  viewOnlyData?: any
  refetch?: any
  setShowInnerTable?: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const UpdateExpenseItemModal = ({
  show,
  handleClose,
  data,
  violationLineItem,
  viewOnlyData,
  refetch,
  setShowInnerTable,
}: Props) => {
  const {userAccountID, userInOrgId, token, baseURL, expenseType, isCorpCreditCardRequiredPopUp} =
    useAppSelector(selectAuth)
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }
  // const [addUpdateCardExpenseItem, { isLoading, isError, error, isSuccess }] = useAddUpdateCardExpenseItemMutation();
  const [
    addUpdateCardExpenseItem,
    {data: addUpdateItemData, isLoading, isError, error, isSuccess},
  ] = useAddUpdateExpenseItemV2WebMutation()
  const [
    deleteReceiptApi,
    {
      data: deleteRecieptData,
      isLoading: deleteRecieptLoading,
      isError: isErrorDeleteReciept,
      error: errorDeleteReciept,
      isSuccess: isSuccessDeleteReciept,
    },
  ] = useDeleteReceiptByExpenseItemIdMutation()

  // const [uploadFileToAzureForMilage] = useUploadFileToAzureMutation();
  // const [uploadFileToAzure, { data: azurefileData, isLoading: fileIsloading, error: fileError, isError: fileIsError }] = useUploadOCRInvoiceMutation();
  const {data: orgDetail, refetch: orgDetailRefetch} = useGetSingleOrganizationQuery(userInOrgId)
  const [showAddUpdateCardModal, setShowAddUpdateCardModal] = useState<boolean>(false)

  const [getItemData, setGetItemData] = useState<any>(null) // Initialize with null
  const fetchItemData = async () => {
    if (show && violationLineItem) {
      try {
        const headers = {
          Authorization: `Bearer ${token}`, // Add your authorization token here
        }
        const itemDataResponse = await axios.get(
          `${baseURL}/api/Expense${API_END_POINTS.getExpenseItemsByExpenseItemId}?expenseItemId=${violationLineItem}`,
          {
            headers, // Include the headers in the request
          }
        )
        const getItemData = itemDataResponse.data
        setGetItemData(getItemData)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }

  useEffect(() => {
    if (show) {
      orgDetailRefetch()
      fetchItemData()
    }
  }, [show])

  const currentDate = new Date()

  const initialValues = {
    expenseItemId: 0,
    expenseId: 0,
    expenseType: {
      id: 0,
      title: '',
    },
    userAccountId: userAccountID,
    expenseCategory: {
      id: 0,
      title: '',
    },
    itemDetail: '',
    vendor: {
      vendorId: 0,
      name: '',
      disc: '',
      address: '',
      active: true,
      email: '',
      phone: '',
    },
    paymentMethod: {
      id: 0,
      title: '',
    },
    currency: {
      id: 2,
      title: '',
    },
    tripType: {
      id: 1,
      title: '',
    },
    expItemLocation: {
      id: 0,
      title: '',
    },
    isKM: true,
    isMile: false,
    milage: 0,
    amount: '0',
    attachmentFile: '',
    file: '',
    itemDate: currentDate.toISOString().split('T')[0],
    startLocation: '',
    endLocation: '',
    invoiceDataDraftId: 0,
    reimbursableDistance: 0,
    startLatLngs: {
      lat: '',
      lng: '',
    },
    endLatLngs: {
      lat: '',
      lng: '',
    },
    mileageRate: '',
    isSplitLineItem: false,
    isSplitCategory: false,
    recordSourceId: 0,
    splitLineItems: [
      {
        splitLineItemId: 0,
        expItemLocation: {
          id: 0,
          title: '',
        },
        amount: '',
        percentage: '',
      },
    ],
    splitCategory: [
      {
        splitCategoryId: 0,
        expItemCategory: {
          id: 0,
          title: '',
        },
        amount: '',
        percentage: 0,
      },
    ],
  }

  const [updateId, setUpdateId] = useState(0)
  const [newId, setNewId] = useState(0)

  const [formValues, setFormValues] = useState(initialValues)

  useEffect(() => {
    if (show) {
      if (data) {
        setUpdateId(data?.expenseItemId)
        formik.setValues({...data})
      } else if (getItemData?.result) {
        setNewId(getItemData?.result?.expenseItemId)
        formik.setValues({...getItemData?.result})
      } else if (Object.keys(formValues).length !== 0) {
        formik.setValues(formValues)
      } else {
        formik.resetForm()
      }
    } else {
      // Reset form values when the modal is closed
      setUpdateId(0)
      setNewId(0)
      formik.resetForm()
    }
  }, [show, data, getItemData?.result])
  const [isSubmitted, setIsSubmitted] = useState(false)
  const formik = useFormik({
    initialValues,
    // validationSchema: validationSchema,
    onSubmit: (values, {resetForm}) => {
      const selectedDate = new Date(formik.values?.itemDate)
      setIsSubmitted(true)
      if (!values.expenseType.id) {
        toast.error(tosterKey.expenseTypeIsRequired)
        return
      } else if (
        !formik.values?.expenseCategory?.id ||
        (formik.values.expenseCategory.id === constraintConfig.categoriesId.other &&
          !values.isSplitCategory)
      ) {
        toast.error(tosterKey.categoryIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id?.toString() !== '14' &&
        orgDetail?.result?.receiptReqMinAmnt < formik.values?.amount &&
        !formik.values?.attachmentFile
      ) {
        toast.error(tosterKey.recieptIsRequired)
        return
      } else if (!formik.values?.itemDate) {
        toast.error(tosterKey.dateIsRequired)
        return
      } else if (selectedDate > currentDate) {
        toast.error(tosterKey.dateCannotBeInFuture)
        return
      } else if (!formik.values?.currency?.id) {
        toast.error(tosterKey.currencyIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id !== constraintConfig.categoriesId.mileage &&
        (!formik?.values.amount ||
          (formik?.values.recordSourceId !== 4 && parseFloat(formik?.values?.amount) <= 0))
      ) {
        toast.error(tosterKey.amountIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id?.toString() !== '14' &&
        orgDetail?.result?.expPolicyMaxLimit < formik?.values?.amount
      ) {
        toast.error(tosterKey.AmountExceedAccordingToExpensePolicyLimit)
        return
      } else if (values.expenseCategory.id.toString() === '14' && !values.tripType?.id) {
        toast.error(tosterKey.tripTypeIsRequired)
        return
      } else if (values.expenseCategory.id.toString() === '14' && !values.startLocation) {
        toast.error(tosterKey.startLocationIsRequired)
        return
      } else if (values.expenseCategory.id.toString() === '14' && !values.endLocation) {
        toast.error(tosterKey.endLocationIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id?.toString() === '14' &&
        !formik.values?.milage
      ) {
        toast.error(tosterKey.distanceIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id?.toString() !== '14' &&
        !formik?.values?.vendor?.vendorId
      ) {
        toast.error(tosterKey.vendorIsRequired)
        return
      } else if (
        formik.values?.expenseCategory?.id?.toString() !== '14' &&
        !formik?.values?.expItemLocation?.id
      ) {
        toast.error(tosterKey.locationIsRequired)
        return
      } else if (!formik.values?.paymentMethod?.id) {
        toast.error(tosterKey.paymentMethodIsRequired)
        return
      } else if (formik.values?.itemDetail?.trim().length > 500) {
        toast.error(tosterKey.expenseItemDetailMustNotExceed500Characters)
        return
      }

      // New validation to check incomplete split line items even when isSplitLineItem is false
      if (values.splitLineItems.length > 0) {
        for (let i = 0; i < values.splitLineItems.length; i++) {
          const splitItem = values.splitLineItems[i]

          if (splitItem.amount && !splitItem.expItemLocation?.id && values.isSplitLineItem) {
            toast.error(`Location is required for split line item ${i + 1}`)
            return
          }
        }
      }

      // Validate required fields within splitLineItem when isSplitLineItem is true
      if (values.isSplitLineItem || values.isSplitCategory) {
        let totalSplitAmount = 0
        if (values.isSplitLineItem) {
          for (let i = 0; i < values.splitLineItems?.length; i++) {
            const splitItem = values.splitLineItems[i]
            if (!splitItem.expItemLocation?.id) {
              toast.error(`Location is required for split line item ${i + 1}`)
              return
            }
            if (!splitItem.amount || Number(splitItem.amount) <= 0) {
              toast.error(`Amount must be greater than 0 for split line item ${i + 1}`)
              return
            }
          }
          totalSplitAmount = values.splitLineItems.reduce(
            (sum: any, lineItem: any) => sum + (parseFloat(lineItem.amount) || 0),
            0
          )
          const roundedTotalSplitAmount = Math.round(totalSplitAmount * 100) / 100
          const totalAmount = Number(values.amount)
          const remainingAmount = totalAmount - roundedTotalSplitAmount
          if (Math.round(remainingAmount * 100) / 100 !== 0) {
            toast.error(`Split amount must match total amount.`)
            return
          }
        }
        if (values.isSplitCategory) {
          for (let i = 0; i < values.splitCategory?.length; i++) {
            const splitCategory = values.splitCategory[i]
            if (!splitCategory.expItemCategory?.id) {
              toast.error(`Category is required for split line item ${i + 1}`)
              return
            }
            if (!splitCategory.amount || Number(splitCategory.amount) <= 0) {
              toast.error(`Amount must be greater than 0 for split line item ${i + 1}`)
              return
            }
          }
          totalSplitAmount = values.splitCategory.reduce(
            (sum: any, lineItem: any) => sum + (parseFloat(lineItem.amount) || 0),
            0
          )
          const roundedTotalSplitAmount = Math.round(totalSplitAmount * 100) / 100
          const totalAmount = Number(values.amount)
          const remainingAmount = totalAmount - roundedTotalSplitAmount
          if (Math.round(remainingAmount * 100) / 100 !== 0) {
            toast.error(`Split amount must match total amount.`)
            return
          }
        }
      }
      addUpdateCardExpenseItem(values)
    },
  })
  const {resetForm} = formik
  const queryUploadToAzureHook =
    formik.values?.expenseCategory?.id === constraintConfig.expenseCategoryID.mileage
      ? useUploadFileToAzureMutation
      : useUploadOCRInvoiceMutation

  const [
    uploadFileToAzure,
    {data: azurefileData, isLoading: fileIsloading, error: fileError, isError: fileIsError},
  ] = queryUploadToAzureHook()
  const [imagePreviewFirst, setImagePreviewFirst] = useState<string | null>(null)
  const [fileName, setFileName] = useState<string | null>(null)
  const [isPdf, setIsPdf] = useState<boolean>(false)

  const handleImageChangeFirst = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setIsPdf(file.type === 'application/pdf')
      const reader = new FileReader()
      reader.onload = async () => {
        setImagePreviewFirst(reader.result as string)
        const formData = new FormData()
        formData.append('file', file)
        const fileName = file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name

        try {
          let response
          if (formik.values?.expenseCategory?.id === constraintConfig.expenseCategoryID?.mileage) {
            response = await uploadFileToAzure(formData) // Pass the FormData object
          } else {
            response = await uploadFileToAzure(formData)
          }

          // Check if the response is successful
          if (response && typeof response === 'object' && 'data' in response) {
            const successMessage = (response as {data?: {message?: string}})?.data?.message
            if (successMessage) {
              toast.success(`${successMessage}`)
            }

            // Set form values based on response
            const data = (response as {data?: any})?.data?.result
            if (data) {
              if (
                formik.values?.expenseCategory?.id === constraintConfig.expenseCategoryID?.mileage
              ) {
                formik.setFieldValue('attachmentFile', data)
                formik.setFieldValue('itemDate', currentDate.toISOString().split('T')[0])
                formik.setFieldValue('amount', '0')
                formik.setFieldValue('vendor.vendorId', 0)
                formik.setFieldValue('vendor.name', '')
                formik.setFieldValue('invoiceDataDraftId', 0)
              } else {
                formik.setFieldValue('attachmentFile', data?.fileURL)
                formik.setFieldValue(
                  'itemDate',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.itemDate
                    : data?.invoiceDate
                )
                formik.setFieldValue(
                  'amount',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.amount
                    : String(data?.amount)
                )
                formik.setFieldValue(
                  'vendor.vendorId',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.vendor.vendorId
                    : data?.vendorInfo?.vendorId
                )
                formik.setFieldValue(
                  'vendor.name',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.vendor.name
                    : data?.vendorInfo?.name
                )

                const currentCategoryId = formik.values?.expenseCategory?.id
                const currentCategoryTitle = formik.values?.expenseCategory?.title

                const ocrCategoryId = data?.categoryId
                const ocrCategoryTitle = data?.categoryName

                if (currentCategoryId === 1 || currentCategoryTitle === 'Please Select Category') {
                  formik.setFieldValue('expenseCategory.id', ocrCategoryId)
                  formik.setFieldValue('expenseCategory.title', ocrCategoryTitle)
                } else if (currentCategoryId > 1) {
                  if (ocrCategoryId > 1) {
                    formik.setFieldValue('expenseCategory.id', ocrCategoryId)
                    formik.setFieldValue('expenseCategory.title', ocrCategoryTitle)
                  } else if (ocrCategoryId === 1 && ocrCategoryTitle === 'Others') {
                  }
                }
                // if (currentCategoryId === null || currentCategoryId === undefined || data?.catagoryId > 1) {
                //   formik.setFieldValue('expenseCategory.id', data?.catagoryId);
                //   formik.setFieldValue('expenseCategory.title', data?.catagoryName);
                // }

                formik.setFieldValue(
                  'paymentMethod.id',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.paymentMethod.id
                    : data?.paymentMethodId
                )
                formik.setFieldValue(
                  'paymentMethod.title',
                  formik.values?.recordSourceId === constraintConfig.recordSourceId.BankFeed
                    ? formik.values?.paymentMethod.title
                    : data?.paymentMethodName
                )
                formik.setFieldValue('invoiceDataDraftId', data?.invoiceDataDraftId)
              }
              // Set the file name in the state
              setFileName(fileName)
            }
          }
        } catch (error) {
          console.error(error)
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const [fileRemoved, setFileRemoved] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const handleRemoveFile = () => {
    // Reset the uploaded file and related states
    // if (data?.attachmentFile) {
    //   deleteReceiptApi({ expenseItemId: data?.expenseItemId })
    // }

    formik.setFieldValue('attachmentFile', null)
    formik.setFieldValue('invoiceDataDraftId', 0)
    setFileRemoved(true)

    // Reset the file input value
    const fileInput = fileInputRef.current
    if (fileInput) {
      fileInput.value = '' // Clear the input value
    }
  }

  useEffect(() => {
    // Check if the file was removed and update UI accordingly
    if (fileRemoved) {
      // Reset file-related states
      setFileName(null)
      setImagePreviewFirst(null)
      // Reset file removed state
      setFileRemoved(false)
    }
  }, [fileRemoved])
  useEffect(() => {
    if (fileIsError && fileError) {
      let errorMessage: string = 'Something went wrong'
      if (
        'data' in fileError &&
        fileError.data &&
        typeof fileError.data === 'object' &&
        'message' in fileError.data
      ) {
        errorMessage = (fileError.data as {message: string}).message
      }
      toast.error(errorMessage)
      formik.setFieldValue('attachmentFile', null)
      setFileRemoved(true)
      // Clear the file input
      const fileInput = fileInputRef.current
      if (fileInput) {
        fileInput.value = '' // Clear the input value
      }
    }
  }, [fileIsError, fileError])
  useEffect(() => {
    if (fileName !== null && imagePreviewFirst !== null) {
      setFileName(null)
      setImagePreviewFirst(null)
    }
  }, [])
  // useEffect(() => {
  //   if (isSuccess) {
  //     toast.success(tosterKey.itemUpdatedSuccessfully);
  //     resetForm()
  //     handleClose();
  //     setIsSubmitted(false);
  //     if (refetch) {
  //       refetch();
  //     }
  //     if (setShowInnerTable) {
  //       setShowInnerTable(null);
  //     }
  //   }
  // }, [isSuccess]);
  useEffect(() => {
    if (isSuccess) {
      const responseData = (addUpdateItemData as any)?.message
      const successMessage = responseData || tosterKey.expenseAddSuccessfully
      toast.success(successMessage)
      resetForm()
      handleClose()
      setIsSubmitted(false)
      if (refetch) {
        refetch()
      }
      if (setShowInnerTable) {
        setShowInnerTable(null)
      }
    }
  }, [isSuccess, addUpdateItemData])
  useEffect(() => {
    if (isSuccessDeleteReciept) {
      const responseData = (deleteRecieptData as any)?.message
      const successMessage = responseData || tosterKey.expenseAddSuccessfully
      toast.success(successMessage)
      if (refetch) {
        refetch()
      }
      if (setShowInnerTable) {
        setShowInnerTable(null)
      }
    }
  }, [isSuccessDeleteReciept, deleteRecieptData])
  const [ExpenseItemErrorMsg, setExpenseItemErrorMsg] = useState('')

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong'
      let validationCode: string | null = null
      if (
        'data' in error &&
        error.data &&
        typeof error.data === 'object' &&
        'message' in error.data
      ) {
        errorMessage = (error.data as {message: string}).message
      }
      if (
        'data' in error &&
        error.data &&
        typeof error.data === 'object' &&
        'validationCode' in error.data
      ) {
        validationCode = (error.data as {validationCode: string}).validationCode
      }
      setExpenseItemErrorMsg(errorMessage)
      toast.error(errorMessage)
      if (validationCode === '6001') {
        setShowAddUpdateCardModal(true)
      }
    }
  }, [isError, error])
  useEffect(() => {
    if (isErrorDeleteReciept && errorDeleteReciept) {
      let errorMessage: string = 'Something went wrong'

      if (
        'data' in errorDeleteReciept &&
        errorDeleteReciept.data &&
        typeof errorDeleteReciept.data === 'object' &&
        'message' in errorDeleteReciept.data
      ) {
        errorMessage = (errorDeleteReciept.data as {message: string}).message
      }
      toast.error(errorMessage)
    }
  }, [isErrorDeleteReciept, errorDeleteReciept])
  useEffect(() => {
    if (
      formik.values.paymentMethod?.id === constraintConfig.paymentMethod.adcsCorporateCreditCard &&
      isCorpCreditCardRequiredPopUp
    ) {
      setShowAddUpdateCardModal(true)
    }
  }, [formik.values.paymentMethod?.id, isCorpCreditCardRequiredPopUp])
  useEffect(() => {
    if (show) {
      setImagePreviewFirst(null)
      setFileName(null)
    }
  }, [show])

  const handleModalClose = () => {
    resetForm()
    setImagePreviewFirst(null) // Clear image preview
    setFileName(null) // Clear file name
    setFormValues(formik.values)
    setIsSubmitted(false)
    handleClose()
  }
  return createPortal(
    <>
      <AddCardModal
        show={showAddUpdateCardModal}
        handleClose={() => setShowAddUpdateCardModal(false)}
        errorMessage={
          ExpenseItemErrorMsg ||
          'You cannot submit corporate expenses because your profile does not have a valid Corporate Credit Card. If you have a ADCS Corp Credit card please update your card details here to proceed with your expense.'
        }
      />
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog custom-modal-size modal-dialog-centered'
        show={show}
        onHide={handleModalClose}
        onEntered={loadStepper}
        backdrop='static'
      >
        <div className='modal-header'>
          <h2>{viewOnlyData ? labelKey.expenseItemDetail : labelKey.updateExpenseItem}</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          {/*begin::Stepper */}
          <div
            ref={stepperRef}
            className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
            id='kt_modal_create_app_stepper'
          >
            {/* begin::Aside*/}
            {/* <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
            <div className='stepper-nav ps-lg-10'>
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>{labelKey.expenseItem}</h3>

                    <div className='stepper-desc'>{labelKey.defineYourExpenceItem}</div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
            {/* begin::Aside*/}

            {/*begin::Content */}
            <div className='flex-row-fluid'>
              {/*begin::Form */}
              <form
                noValidate
                id='kt_modal_create_app_form'
                onSubmit={formik.handleSubmit}
                className='position-relative'
              >
                <Step2
                  formik={formik}
                  handleImageChangeFirst={handleImageChangeFirst}
                  imagePreviewFirst={imagePreviewFirst}
                  fileName={fileName}
                  fileIsloading={fileIsloading}
                  handleRemoveFile={handleRemoveFile}
                  fileInputRef={fileInputRef}
                  orgDetail={orgDetail}
                  isPdf={isPdf}
                  viewOnlyData={viewOnlyData}
                  show={show}
                  isSubmitted={isSubmitted}
                />
                <Step5 formik={formik} fileName={fileName} />

                {/*begin::Actions */}
                <div className='d-flex flex-stack pt-10'>
                  {/* <div className='me-2'>
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-3 me-1'
                    />{' '}
                    {labelKey.previous}
                  </button>
                </div> */}
                  {/* <div> */}
                  {viewOnlyData === false ? (
                    <button
                      type='submit'
                      className='btn btn-lg btn-primary ms-auto'
                      // data-kt-stepper-action='submit'
                      disabled={isLoading}
                    >
                      {!isLoading && (
                        <span className='indicator-label'>
                          {labelKey.save}{' '}
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                          />
                        </span>
                      )}
                      {isLoading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {labelKey.pleaseWait}...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  ) : (
                    <span className='btn btn-light-primary ms-auto' onClick={handleClose}>
                      Cancel
                    </span>
                  )}

                  {/* <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    {labelKey.nextStep}{' '}
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-1 me-0'
                    />
                  </button> */}
                  {/* </div> */}
                </div>
                {/*end::Actions */}
              </form>
              {/*end::Form */}
            </div>
            {/*end::Content */}
          </div>
          {/* end::Stepper */}
        </div>
      </Modal>
    </>,
    modalsRoot
  )
}

export {UpdateExpenseItemModal}
